import { UserActions } from './../ActionTypes';

export const setAllUsers = (users, rowCount) => ({
    type: UserActions.SetAll,
    users,
    rowCount
});
